import { Stack } from '@mui/material';
import storeConnector from '@store/storeConnector';
import { useMemo } from 'react';
import { useLocation } from 'react-router';
import Meter from './Meter';
import SiteSOC from './SiteSOC';
import System from './SystemList';
import UIBox from './UIBox';

interface SystemMeterProps {
  isHome?: boolean;
}

const SystemMeter = ({ isHome }: SystemMeterProps) => {
  const WrappingTag = UIBox;
  const location = useLocation();
  const { isTeslaPage, isSunPage } = useMemo(
    () => ({
      isTeslaPage: location.pathname.endsWith('tesla'),
      isSunPage: location.pathname.startsWith('/sun/'),
    }),
    [location.pathname],
  );

  return (
    <Stack
      direction={isHome ? 'column' : 'row'}
      spacing={4}
      height={'auto'}
      sx={{
        ...(isHome && { flex: 1 }),
      }}
    >
      <WrappingTag
        style={{
          flexGrow: 1,
          ...(!isHome && { height: 'auto' }),
        }}
      >
        <System
          isChild
          isHome={isHome}
          sectionId={
            isTeslaPage
              ? 'teslaSystemPointsList'
              : isSunPage
                ? 'pvSystemPointsList'
                : undefined
          }
        />
      </WrappingTag>
      <WrappingTag
        style={{
          flexGrow: 1,
          ...(!isHome && { height: 'auto' }),
        }}
      >
        <Stack
          spacing={2}
          style={{
            flex: 1,
            justifyContent: 'space-between',
          }}
        >
          <Meter isChild />
          {!isSunPage && !isHome && <SiteSOC />}
        </Stack>
      </WrappingTag>
    </Stack>
  );
};

export default storeConnector(SystemMeter, {
  user: ['role'],
  mqtt: ['topicDict'],
  service: ['isControlsInterLocked'],
});
